import { useRouter } from 'next/router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGenerateResetPasswordEmailMutation, useResetUserPasswordMutation } from '../../graphql/types';
import ButtonComp from '../components/login/Button';
import { LoginInputComp } from '../components/login/Inputs';
import LoginWrapper from '../components/login/Layout';
import { SimpleInputState } from '../customTypes';
import message from 'antd/lib/message';

const PasswordReset = () => {
  const { t } = useTranslation('page');
  const router = useRouter();
  const [email, setEmail] = useState<SimpleInputState>({
    value: '',
    error: '',
  });
  const [newPassword, setNewPassword] = useState<SimpleInputState>({
    value: '',
    error: '',
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [generateResetPassword] = useGenerateResetPasswordEmailMutation();
  const [resetUserPassword] = useResetUserPasswordMutation();

  const handleResetPass = async () => {
    setLoading(true);
    await generateResetPassword({
      variables: {
        email: email.value,
      },
    })
      .then(result => {
        if (result.data?.generatePasswordResetEmail.success) {
          message.success(result.data?.generatePasswordResetEmail.message);
        } else {
          message.error(result.data?.generatePasswordResetEmail.message);
        }
      })
      .catch(() => {
        message.error('Something went wrong!');
      });
    setLoading(false);
  };

  const handleUpdatePassword = async () => {
    setLoading(true);

    await resetUserPassword({
      variables: {
        token: router.query.token ? (router.query.token as string) : '',
        password: newPassword.value,
      },
    })
      .then(result => {
        if (result.data?.resetUserPassword.success) {
          message.success(result.data?.resetUserPassword.message);
          router.push('/');
        } else {
          message.error(result.data?.resetUserPassword.message);
        }
      })
      .catch(() => {
        message.error('Something went wrong!');
      });

    setLoading(false);
  };

  return (
    <LoginWrapper isResetPass>
      <h1
        className="title"
        style={{
          textAlign: 'left',
          marginBottom: 20,
        }}>
        Password reset
      </h1>
      <LoginInputComp
        placeholder={router.query.token ? t('login.newPassword') : 'Email'}
        state={router.query.token ? newPassword : email}
        setState={router.query.token ? setNewPassword : setEmail}
        disabled={loading}
        type={router.query.token ? 'password' : 'email'}
      />
      {router.query.token ? (
        <ButtonComp title={t('events.submit')} cl="#000" boderCl="#FEC400" bg="#FEC400" onClick={handleUpdatePassword} isLoading={loading} disabled={loading} />
      ) : (
        <ButtonComp
          title={t('login.resetPassword')}
          cl="#000"
          boderCl="#FEC400"
          bg="#FEC400"
          onClick={handleResetPass}
          isLoading={loading}
          disabled={loading}
        />
      )}
    </LoginWrapper>
  );
};

export default PasswordReset;
